import {forEach} from "../../../common/js/Helpers";

document.addEventListener('DOMContentLoaded', () => {
    /**
     * fixes HTML5Fallback issue where the disabled property was not set in the right way
     */
    function refreshShippingAddressFields() {
        let fields = document.querySelectorAll('.eventgallery-checkout-address input');
        forEach(fields, (elm => {
            elm.isRequired = !!elm.getAttribute('required');
            elm.isDisabled = !!elm.getAttribute('disabled');
        }))
    }

    /**
     * BEGIN  Handles the different shipping / billing address switch
     */
    function disableRequiredForShipping() {
        forEach(document.querySelectorAll('.shipping-address'), (elm)=> {elm.setAttribute('disabled', 'disabled');});
        forEach(document.querySelectorAll('.shipping-address-fieldset .is-required'), (elm) => {elm.classList.remove('required');})
        document.querySelector('.shipping-address-fieldset').style.display = 'none';
        refreshShippingAddressFields();
    }

    function enableReqiredForShipping() {
        forEach(document.querySelectorAll('.shipping-address'), (elm)=> {elm.removeAttribute('disabled');});
        forEach(document.querySelectorAll('.shipping-address-fieldset .is-required'), (elm) => {elm.classList.add('required');})
        document.querySelector('.shipping-address-fieldset').style.display = 'block';
        refreshShippingAddressFields();
    }


    function handleShippingAddressRequiredField() {
        if (document.querySelector('#shiptodifferentaddress-false').getAttribute('checked')) {
            disableRequiredForShipping();
        } else {
            enableReqiredForShipping();
        }
    }

    document.getElementById('shiptodifferentaddress-false')?.addEventListener('click', (e) => disableRequiredForShipping());
    document.getElementById('shiptodifferentaddress-true')?.addEventListener('click', (e) => enableReqiredForShipping());

    /**
     *  END different shippinng address handling
     *
     */

    function hideAddressForms(containerSelector) {
        //console.log('hide', containerSelector, document.querySelectorAll(containerSelector + ' .eg-is-required').length)
        forEach(document.querySelectorAll(containerSelector + ' .eg-is-required'), (elm) => {elm.classList.remove('required')});
        forEach(document.querySelectorAll(containerSelector + ' .eg-is-required'), (elm) => {elm.removeAttribute('required')});
        forEach(document.querySelectorAll(containerSelector + ' input'), (elm) => {elm.setAttribute('disabled', 'disabled')});
        forEach(document.querySelectorAll(containerSelector + ' textarea'), (elm) => {elm.setAttribute('disabled', 'disabled')});
        handleShippingAddressRequiredField();
        forEach(document.querySelectorAll(containerSelector), (elm) => {elm.style.display = 'none'});
    }

    function showAddressForms(containerSelector) {
        //console.log('show', containerSelector, document.querySelectorAll(containerSelector + ' .eg-is-required').length)
        forEach(document.querySelectorAll(containerSelector + ' .eg-is-required'), (elm) => {elm.classList.add('required')});
        forEach(document.querySelectorAll(containerSelector + ' .eg-is-required'), (elm) => {elm.setAttribute('required', 'required')});
        forEach(document.querySelectorAll(containerSelector + ' input'), (elm) => {elm.removeAttribute('disabled')});
        forEach(document.querySelectorAll(containerSelector + ' textarea'), (elm) => {elm.removeAttribute('disabled')});
        handleShippingAddressRequiredField();
        forEach(document.querySelectorAll(containerSelector), (elm) => {elm.style.display = 'block'});
    }

    function handleAddressFormVisibility(element) {

        if (element.dataset.needsAddressData === 'false') {
            hideAddressForms('.eventgallery-checkout-form-with-address');
            showAddressForms('.eventgallery-checkout-form-without-address');
        } else {
            hideAddressForms('.eventgallery-checkout-form-without-address');
            showAddressForms('.eventgallery-checkout-form-with-address');
        }
        refreshShippingAddressFields();
    }


    forEach(document.querySelectorAll('input[name=shippingid]'), (elm) => {
        elm.addEventListener('click', () => {
            handleAddressFormVisibility(elm);
        })
    });


    /*
    * Init the form state
     */

    // save the required state for restoring it if necessary
    forEach(document.querySelectorAll('[required]'), (elm) => { elm.classList.add('eg-is-required')})


    handleShippingAddressRequiredField();

    let checkedShippingElements = document.querySelectorAll('input[name=shippingid][checked=checked]');
    if (checkedShippingElements.length>0) {
        handleAddressFormVisibility(checkedShippingElements[0]);
    } else {
        let shippingElements = document.querySelectorAll('input[name=shippingid]');
        if (shippingElements.length>0) {
            shippingElements[0].click();
        } else {
            // this happens if no shipping methods are available.
            hideAddressForms('.eventgallery-checkout-form-with-address');
            hideAddressForms('.eventgallery-checkout-form-without-address');
        }
    }

});


